import React from 'react'

export const FormatConnectionCode = props => {
  const {
    code,
  } = props

  const fmt = () => {
    const chunks = []
    if (!code) {
      return
    }
    for (let i = 0; i < (code.length) / 4; i += 1) {
      const start = i * 4
      const end = (i + 1) * 4
      chunks.push(code.slice(start, end))
    }
    const formatted = chunks.join('-')
    return (
      formatted.toUpperCase()
    )
  }
  return (
    <span>
      {fmt()}
    </span>
  )
}

export default FormatConnectionCode



// WEBPACK FOOTER //
// ./src/legacy/components/FormatConnectionCode/FormatConnectionCode.jsx